require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-back-pain-exercise.json") })
        }
      }, "path---blog-back-pain-exercise");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-back-pain-exercise!./.cache/json/blog-back-pain-exercise.json
// module id = 277
// module chunks = 231608221292675